import type { ReactNode } from 'react';
import { Button } from '@mantine/core';
import { Structure, type StructureProps } from '@epihub/web/src/components/Structure';

type ErrorView1Props = StructureProps & {
  message: ReactNode;
  cta?: {
    text: ReactNode;
    onClick?: () => void;
  } | { node: ReactNode };
};

export const ErrorView1 = ({ message, cta, ...boxProps }: ErrorView1Props) => {
  return (
    <Structure vcenter hcenter {...boxProps}>
      {message}
      {cta && 'text' in cta && (
        <Button mt={48} disabled={!cta.onClick} onClick={cta.onClick}>
          {cta.text}
        </Button>
      )}
      {cta && 'node' in cta && (
        <div>
          {cta.node}
        </div>
      )}
    </Structure>
  );
};
